import axios from 'axios';

export const getConfig = (data) =>
  axios
    .post('/api/get-config', data)
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const allItemServices = () =>
  axios
    .post('/api/ds-item-service', {
      op: 'list',
      convert: true,
      fullConvert: true,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const getService = (id) =>
  axios
    .post('/api/ds-item-service', {
      op: 'read',
      convert: true,
      fullConvert: true,
      item: {
        id: id,
      },
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const createFastItemService = (values) =>
  axios
    .post('/api/create-fast-item-service', values)
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/item-services/_api.js